import {
 bexHttpClient
} from '../../clients';

/**
 * Service for the WhatsApp Baileys Bridge via the BeX Server proxy.
 * Routes: /cm/whatsapp/* — authenticated via user-session cookie (withCredentials: true).
 */
class BaileysBridgeService {

    async generateQr(organizationId: string, subOrganizationId: string, address?: string, mode?: 'listener', force?: boolean): Promise<any> {
        const params = new URLSearchParams({
 subOrganizationId
});
        if (address) params.append('address', address);
        // mode=listener pairs the number as a receive-only group monitor: messages are
        // harvested, the assistant is never invoked, nothing is sent back. Omitted =
        // normal conversational channel. The Bridge persists the mode across restarts.
        if (mode === 'listener') params.append('mode', 'listener');
        // force = explicit Re-authorize: the bridge re-links even a connected session
        // (tears it down, wipes creds, fresh QR). Never sent on plain initial connects.
        if (force) params.append('force', 'true');
        return bexHttpClient.get(`/whatsapp/qr/${organizationId}?${params.toString()}`);
    }

    async checkStatus(organizationId: string, subOrganizationId: string, address: string): Promise<any> {
        const params = new URLSearchParams({
 subOrganizationId,
address
});
        return bexHttpClient.get(`/whatsapp/status/${organizationId}?${params.toString()}`);
    }

    // Groups the connected session participates in (id + name), for the listener source
    // picker. Only valid once the session is connected.
    async getGroups(organizationId: string, subOrganizationId: string, address: string): Promise<any> {
        const params = new URLSearchParams({
 subOrganizationId,
address
});
        return bexHttpClient.get(`/whatsapp/groups/${organizationId}?${params.toString()}`);
    }

    // Individual contacts the session has learned about (history sync + inbound DMs), for
    // the "pick specific people" filter. Best-effort/eventual — not a complete address book.
    async getContacts(organizationId: string, subOrganizationId: string, address: string): Promise<any> {
        const params = new URLSearchParams({
 subOrganizationId,
address
});
        return bexHttpClient.get(`/whatsapp/contacts/${organizationId}?${params.toString()}`);
    }

    async saveChannel(organizationId: string, data: { subOrganizationId: string; topic: string; address: string; assistantId?: string; provider?: string; receive_enabled?: boolean; send_mode?: 'auto' | 'tool' | 'disabled'; collectionId?: string; receive_filter?: 'all' | 'groups' | 'individuals' | 'selected_groups' | 'selected'; receive_sources?: string[] }): Promise<any> {
        return bexHttpClient.post(`/whatsapp/save-channel/${organizationId}`, data);
    }

    async sendMessage(organizationId: string, data: { to: string; message: string }): Promise<any> {
        return bexHttpClient.post(`/whatsapp/send/${organizationId}`, data);
    }

    async disconnect(organizationId: string, subOrganizationId: string, address: string): Promise<any> {
        const params = new URLSearchParams({
 subOrganizationId,
address
});
        return bexHttpClient.delete(`/whatsapp/disconnect/${organizationId}?${params.toString()}`);
    }

    // Abandon an in-flight QR / pairing-code attempt. NOT disconnect(): that logs a linked
    // device out of WhatsApp. The bridge refuses this for a connected session and is
    // idempotent, so it is safe to fire on an explicit Stop and on unmount.
    async cancelLink(organizationId: string, subOrganizationId: string, address: string): Promise<any> {
        return bexHttpClient.post(`/whatsapp/cancel-link/${organizationId}`, {
            subOrganizationId,
            address,
        });
    }

    async getPairingCode(organizationId: string, subOrganizationId: string, address: string, phoneNumber: string): Promise<any> {
        return bexHttpClient.post(`/whatsapp/pairing-code/${organizationId}`, {
            subOrganizationId,
            address,
            phoneNumber,
        });
    }
}

const baileysBridgeService = new BaileysBridgeService();
export { baileysBridgeService };
